import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import Footer from '../../componets/Footer';
import { Link } from 'react-router-dom';
import ContactUs from './ContactUs';

const toolsConfig = [
  {
    id: 1,
    name: "GIS Dashboard",
    text: "Interactive maps with real-time geospatial data.",
    icon: "img/GIS.png",

  },
  {
    id: 2,
    name: "MIS Dashboard",
    text: "Organize and analyze critical urban data.",
    icon: "img/Misdashboard.png",

  },
  {
    id: 3,
    name: "Spatial Analysis",
    text: "Discover patterns and trends with geospatial tools.",
    icon: "img/Misdashboard.png",

  },
  {
    id: 4,
    name: "Decision Support System",
    text: "Make data-driven plans with predictive models.",
    icon: "img/Spatialanalysis.png",
  },

];

const images = [
  { src: "path/to/projectPlan", alt: "Project Plan" },
  { src: "path/to/projectShakti", alt: "Project Shakti" },
  { src: "path/to/projectMission", alt: "Project Mission" },
  { src: "path/to/projectMap", alt: "Project Map" },
  { src: "path/to/projectCity", alt: "Project City" },
  { src: "path/to/projectPalika", alt: "Project Palika" },
  { src: "path/to/projectAbpas", alt: "Project Abpas" },
  { src: "path/to/projectAmrut", alt: "Project Amrut" },
  { src: "path/to/projectSam", alt: "Project Sam" },
  { src: "path/to/janSunbai", alt: "Jan Sunbai" },
];

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="slick-arrow slick-next" onClick={onClick}>
      <img src="img/right-arrow.svg" alt="image" />
    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="slick-arrow slick-prev" onClick={onClick}>
      <img src="img/left-arrow.svg" alt="image" width="20px" height="20px" />
    </div>
  );
};
function Home() {
  const [currentStage, setCurrentStage] = useState(1);
  const [showAll, setShowAll] = useState(false);
  const [browserInfo, setBrowserInfo] = useState({ browserName: "", browserVersion: "" });
  const handleToggleShow = () => {
    setShowAll(!showAll);
  };

  const cards = [
    { imgSrc: "img/Project-cardplan.svg" },
    { imgSrc: "img/Project-cardshakti.png" },
    { imgSrc: "img/Projectcardmission.png" },
    { imgSrc: "img/Projectcardmap.png" },
    { imgSrc: "img/Projectcardcity.png" },
    { imgSrc: "img/ProjectcardEpalika.png" },
    { imgSrc: "img/Projectcardabpas.png" },
    { imgSrc: "img/Projectamrut.png" },
    { imgSrc: "img/Projectcardsam.png" },
    { imgSrc: "img/Projectcardjan.png" },
  ];

  const visibleCards = showAll ? cards : cards.slice(0, 4);


  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Number of tools to show at once
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 991, // For mobile devices
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // For mobile devices
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // For small devices
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };


  const getBrowserInfo = () => {
    const userAgent = navigator.userAgent;
    let browserName = "Unknown Browser";
    let browserVersion = "Unknown Version";

    if (userAgent.includes("Firefox")) {
      browserName = "Firefox";
      browserVersion = userAgent.match(/Firefox\/(\d+\.\d+)/)?.[1] || "Unknown";
    } else if (userAgent.includes("Edg")) {
      browserName = "Microsoft Edge";
      browserVersion = userAgent.match(/Edg\/(\d+\.\d+)/)?.[1] || "Unknown";
    } else if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
      browserName = "Google Chrome";
      browserVersion = userAgent.match(/Chrome\/(\d+\.\d+)/)?.[1] || "Unknown";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      browserName = "Safari";
      browserVersion = userAgent.match(/Version\/(\d+\.\d+)/)?.[1] || "Unknown";
    } else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
      browserName = "Opera";
      browserVersion = userAgent.match(/OPR\/(\d+\.\d+)/)?.[1] || "Unknown";
    } else if (userAgent.includes("Trident") || userAgent.includes("MSIE")) {
      browserName = "Internet Explorer";
      browserVersion = userAgent.match(/(?:MSIE |rv:)(\d+\.\d+)/)?.[1] || "Unknown";
    }

    return { browserName, browserVersion };
  };

  console.log(" You're using:", browserInfo.browserName, browserInfo.browserVersion)

  useEffect(() => {
    setBrowserInfo(getBrowserInfo());
  }, []);
  return (
    <>
      <section id="home">
        <div className='banner-container'>
          <div className='layer'>
            <div className='banner-title'>
              <h6 className='m-0'>Welcome to the Urban Data Analytics</h6>
              <h6 className='m-0'>Center of Madhya Pradesh</h6>
              <p className='mt-4'>Empowering decision-makers with geospatial intelligence for smarter cities</p>
             
             <div
  style={{
    display: "flex",
    gap: "18px",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap"
  }}
>


 {/* AMRUT CARD */}
  <Link to="https://www.urbangis.mp.gov.in/ugpin/HaritVan/indexharit" style={{ textDecoration: "none" }}>
    <div
      style={{
        width: "190px",
        height: "165px",
        borderRadius: "18px",
        overflow: "hidden",
        position: "relative",
        cursor: "pointer",
        backgroundImage: "url('/img/namo-harit.png')",
        backgroundSize: "70% 70%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",       
        boxShadow: "0 8px 22px rgba(0,0,0,0.20)",
        transition: "transform 0.3s ease"
      }}
    >
      <div
        style={{
          position: "absolute",
          bottom: "0",
          left: "0",
          width: "100%",
          padding: "0px 5px",
          textAlign: "center",
         background: "linear-gradient(90deg, rgb(9, 132, 95) 0%, rgb(136, 168, 148) 50%, rgb(250, 253, 252) 100%)",
         color: "#000",
          fontSize: "18px",
          fontWeight: "700"
        }}
      >
        Green Deck
      </div>
    </div>
  </Link>


  {/* SMART CITY CARD */}
  <Link to="https://www.urbangis.mp.gov.in/ugpin" style={{ textDecoration: "none" }}>
    <div
      style={{
        width: "190px",
        height: "165px",
        borderRadius: "18px",
        overflow: "hidden",
        position: "relative",
        cursor: "pointer",
        backgroundImage: "url('/img/ugpin.png')",
        backgroundSize: "70% 70%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        boxShadow: "0 8px 22px rgba(0,0,0,0.20)",
        transition: "transform 0.3s ease"
      }}
    >
      <div
        style={{
          position: "absolute",
          bottom: "0",
          left: "0",
          width: "100%",
          padding: "0px 5px",
          textAlign: "center",
         background: "linear-gradient(90deg, rgb(9, 132, 95) 0%, rgb(136, 168, 148) 50%, rgb(250, 253, 252) 100%)",
         
          color: "#000",
          fontSize: "18px",
          fontWeight: "700"
        }}
      >
        UGPIN
         
      </div>
    </div>
  </Link>

  {/* AMRUT CARD */}
  <Link to="/login" style={{ textDecoration: "none" }}>
    <div
      style={{
        width: "190px",
        height: "165px",
        borderRadius: "18px",
        overflow: "hidden",
        position: "relative",
        cursor: "pointer",
        backgroundImage: "url('/img/garud-mp-hone.png')",
        backgroundSize: "85% auto",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        boxShadow: "0 8px 22px rgba(0,0,0,0.20)",
        transition: "transform 0.3s ease"
      }}
    >
      <div
        style={{
          position: "absolute",
          bottom: "0",
          left: "0",
          width: "100%",
           padding: "0px 5px",
          textAlign: "center",
         background: "linear-gradient(90deg, rgb(9, 132, 95) 0%, rgb(136, 168, 148) 50%, rgb(250, 253, 252) 100%)",
         
          color: "#000",
          fontSize: "18px",
          fontWeight: "700"
        }}
      >
        MPGarud 
      </div>
    </div>
  </Link>




</div>
           
           
            </div>
            <div className='bannermap-container'>
              {/* <img src="img/Landing-front-curve.png" alt='map' className='bannermapimg bannermapimg-lg' /> */}
                    <img src="img/landing-front-curve-new.svg" alt='map' className='bannermapimg bannermapimg-lg' />
            </div>
          </div>
        </div>
      </section>

      <section id="about">
        <div className='about-container' >
          <div className='row gx-0 justify-content-between'>
            <div className="col-xl-6 col-lg-6 col-md-5">
              <div className='about-title'>
                <h6 className='m-0'>About Urban Data Analytics</h6>
                {/* <img src="img/vectorline.svg" alt='svg' /> */}
                 <img src="img/vectorline-new.svg" alt='svg' />
                <p className=''>Rate of urbanisation in Madhya Pradesh is fast reaching the National average of 28%. It is expected to cross the 30% mark in another 15 years. Most of the increase in urban population in the state is driven by increase in number of habitations entering the urban strata rather than increase in population of existing urban area.</p>
                <div className='knowdiv'>
                  <Link to='/aboutus'><button>Know more</button></Link>
                </div>
              </div>
            </div>

            <div className="col-xl-5 col-lg-6 col-md-7">
              <div className='row justify-content-center' style={{ rowGap: "20px" }}>
                <div className="col-md-6 col-6">
                  <div className='about-card'>
                    <img src="img/Innovativesolutions.png" alt='tools' />
                    <h6>Innovative Solutions</h6>
                  </div>
                </div>
                <div className="col-md-6 col-6">
                  <div className='about-card'>
                    <img src="img/focusedtools.png" alt='tools' />
                    <h6>User Friendly UI</h6>
                  </div>

                </div>
                <div className='col-md-6 col-6'>
                  <div className='about-card'>
                    <img src="img/user-friendly-ul.svg" alt='tools' />
                    <h6>Focused Tools</h6>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </section>

      <section id='projects'>
        <div className='project-cotaniner'>
          <div className='row gx-0 justify-content-center'>
            <div className='col-md-8'>
              <h6 className='project-title m-0'>Projects</h6>
              <p className='project-p'>UADD has its own geo portal and the department maintains spatial and non-spatial data of ULBs. Apart from this, the department is using or intends to use GIS in many departmental projects (like ABPAS, E Nagar Palika, AMRUT, solid waste management etc.) and some government of Madhya Pradesh and Government of India projects (PM Gati shakti etc.)</p>
              <p className='project-pera gradient-text'>Some major inter & intra department GIS related project, in which uadd deals:</p>
            </div>
          </div>
          <div className=''>

            <div className='row gx-0 justify-content-center projectcard-lg'>
              {/* <div className='col-xxl-8 col-xl-9 col-lg-11 col-md-12 col-12 p-0'> */}
              <div className=''>
                <div className='container-project-card'>
                  <div className='projectcard-container'>
                    <div className='projectcarddiv'>
                      <img src="img/Project-cardplan.svg" />
                      {/* <h6 className='projecttitle'>GIS based AMRUT master plan</h6> */}
                    </div>
                    <div className=' projectcarddiv'>
                      <img src="img/Project-cardshakti.png" />
                    </div>
                    <div className=' projectcarddiv'>
                      <img src="img/Projectcardmission.png" />
                    </div>
                    <div className='projectcarddiv'>
                      <img src="img/Projectcardmap.png" />
                    </div>
                    <div className='projectcarddiv'>
                      <img src="img/Projectcardcity.png" />
                    </div>
                    <div className='projectcarddiv'>
                      <img src="img/ProjectcardEpalika.png" />
                    </div>
                    <div className=' projectcarddiv'>
                      <img src="img/Projectcardabpas.png" />
                    </div>
                    <div className=' projectcarddiv'>
                      <img src="img/Projectamrut.png" />
                    </div>
                    <div className=' projectcarddiv'>
                      <img src="img/Projectcardsam.png" />
                    </div>
                    <div className=' projectcarddiv'>
                      <img src="img/Projectcardjan.png" />
                    </div>

                  </div>
                </div>
              </div>
            </div>



            <div className="row gx-0 justify-content-center projectcard-sm">
              <div className="col-xl-8 col-lg-12 col-md-12 col-12 p-0">
                <div className="container-project-card">
                  <div className="projectcard-container">
                    {visibleCards.map((card, index) => (
                      <div className="projectcarddiv" key={index}>
                        <img src={card.imgSrc} alt={`Project ${index + 1}`} />
                      </div>
                    ))}
                  </div>
                  <div className="text-center mt-3">
                    <button
                      onClick={handleToggleShow}
                      className="btn btn-primary"
                      style={{
                        padding: '10px 20px',
                        borderRadius: '20px',
                        background: '#1F509A',
                        color: '#FFF',
                        border: 'none',
                      }}
                    >
                      {showAll ? 'View Less' : 'View More'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id='features'>
        <div className='featurebgsm'>
          <div>
            <div className='feature-cotaniner feature-container-sm'>
              <div className='feature-layer'>
                <div className='row gx-0 align-items-center'>
                  <div className='col-xl-6 col-lg-4 col-md-12 align-items-center'>
                    <div className='feature-leftdiv'>
                      <h6 className='m-0 feature-white'>Features That Empower Your</h6>
                      <h6 className='m-0 feature-dark'>GIS Experience</h6>
                      <p className="m-0">Explore, analyze, and visualize like never before with cutting-edge tools and seamless integration.</p>
                    </div>
                  </div>
                  <div className='col-xl-6 col-lg-8 col-md-12'>
                    <div className='row feature-lg' style={{ rowGap: '20px' }}>
                      <div className='col-md-6 col-sm-6 col-12'>
                        <div className='feature-card'>
                          {/* <img src="img/GIS.png" alt='gis' /> */}
                           <img src="img/gis-dashboard-new.svg" alt='gis' />
                          <div>
                            <h6 className='m-0'>GIS Dashboard</h6>
                            <p className='mt-1 mb-0'>Interactive maps with real-time geospatial data.</p>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6 col-sm-6 col-12'>
                        <div className='feature-card'>
                          {/* <img src="img/Misdashboard.png" alt='mis' /> */}
                            <img src="img/mis-dashboard-new.svg" alt='mis' />
                          <div>
                            <h6 className='m-0'>MIS Dashboard</h6>
                            <p className='mt-1 mb-0'>Organize and analyze critical urban data.</p>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6 col-sm-6 col-12'>
                        <div className='feature-card'>
                          {/* <img src="img/Spatialanalysis.png" alt='mis' /> */}
                            <img src="img/spatial-analysis-new.svg" alt='mis' />
                          <div>
                            <h6 className='m-0'>Spatial Analysis</h6>
                            <p className='mt-1 mb-0'>Discover patterns and trends with geospatial</p>
                            <p className='m-0'>tools.</p>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6 col-sm-6 col-12'>
                        <div className='feature-card'>
                          {/* <img src="img/decisionsystem.png" alt='mis' /> */}
                            <img src="img/decision-system-new.svg" alt='mis' />
                          <div>
                            <h6 className='m-0'>Decision Support System</h6>
                            <p className='mt-1 mb-0'>Make data-driven plans with predictive models.</p>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div className='feature-sm featureslider'>
                      <Slider {...settings}>
                        {toolsConfig.map((tool) => (
                          <div key={tool.id} className="tool-card">
                            <div
                              type="button"
                              onClick={() => setCurrentStage(tool.id)}
                              className={`tool-btn feature-card ${currentStage === tool.id ? "active" : ""}`}
                            >
                              <div>
                                <img src={tool.icon} alt={tool.name} />
                              </div>
                              <div>
                                <h6 className="m-0">{tool.name}</h6>
                                <p className='mt-1 mb-0'>{tool.text}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="data-container">
            <div className='data-layer'>
              <div className='row gx-0 justify-content-center'>
                <div className='col-md-8'>
                  <div className='data-title'>
                    <h6 className='m-0'>Seamless Data Integration for</h6>
                    <h6 className='m-0'>Comprehensive Insights</h6>
                    <p className='m-0'>Combine geospatial, environmental, and urban datasets effortlessly to create a unified view of your city's challenges and opportunities</p>
                  </div>
                </div>

                <div className='col-xl-10 col-lg-11 col-md-12 mt-5'>
                  <div className='row justify-content-center' style={{ rowGap: '20px' }}>
                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12'>
                      <div className='integration-card'>
                        <img src="img/Urbandata.png" alt='Uraban Data' />
                        <h6 className='m-0'>Urban Data</h6>
                        <p className='m-0'>Include datasets on drainage systems, urban land, and road networks.</p>
                      </div>
                    </div>
                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12'>
                      <div className='integration-card'>
                        <img src="img/Satellitedata.png" alt='Setellite Data' />
                        <h6 className='m-0'>Satellite Data</h6>
                        <p className='m-0'>Use satellite imagery to track flooding in real-time or analyze events.</p>
                      </div>
                    </div>
                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12'>
                      <div className='integration-card'>
                        <img src="img/terrainmodel.png" alt='Terrain Model' />
                        <h6 className='m-0'>DEM & Terrain Model</h6>
                        <p className='m-0'>Integrate high-resolution DEMs to analyze water flow and flood spread.</p>
                      </div>
                    </div>
                    <div className='col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12'>
                      <div className='integration-card'>
                        <img src="img/hydrologicaldata.png" alt='Hydrological Data' />
                        <h6 className='m-0'>Hydrological Data</h6>
                        <p className='m-0'>Stream data from river gauge stations, reservoirs, and weather services.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section id="contact-us">
        <ContactUs />
      </section>


    </>
  )
}

export default Home

